<template>
  <div class="col">
    <div class="row mt-3">
      <div class="col-lg-12">
        <form @submit.prevent="search">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Filters</h4>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    for="Login"
                    class="control-label"
                  >Logins:</label>
                  <v-select
                    multiple
                    required
                    :taggable="true"
                    :searchable="true"
                    v-model="params.Logins"
                    chips
                    placeholder="Select logins"
                    class="custom-select form-control noclose"
                    :select-on-key-codes="[188, 13]"
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="false"
                        v-bind="attributes"
                        v-on="events"
                      >
                    </template>
                    <template slot="no-options">
                          &nbsp;
                    </template>
                  </v-select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    for="FromDate"
                    class="control-label"
                  >From Date:</label>
                  <input
                    type="date"
                    class="form-control m-input  m-input--solid"
                    id="FromDate"
                    placeholder="From Date"
                    required
                    v-model="params.FromDate"
                    min="2016-04-01"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    for="ToDate"
                    class="control-label"
                  >To Date:</label>
                  <input
                    type="date"
                    class="form-control m-input  m-input--solid"
                    id="ToDate"
                    placeholder="To Date"
                    required
                    v-model="params.ToDate"
                    min="2016-04-01"
                  >
                </div>
                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group"
                >
                  <label
                    for="compareWith"
                    class="control-label"
                  >Generate report:</label>
                  <select
                    class="custom-select form-control m-input--solid"
                    v-model="report"
                    @change="generateReport"
                    :disabled="this.params.Logins.length == 0"
                    :title="this.params.Logins.length == 0 ? 'Please select at least one login' : ''"
                  >
                    <option value="">
                      None
                    </option>
                    <option
                      value="30-days-global"
                    >
                      30 days vs Global
                    </option>
                    <option
                      value="30-days-province"
                    >
                      30 days same Provinces
                    </option>
                    <option
                      value="30-days-location"
                    >
                      30 days same Locations
                    </option>
                    <option
                      value="30-days-location-es"
                    >
                      30 days same Locations (Español)
                    </option>
                    <option
                      value="90-days-global"
                    >
                      90 days vs Global
                    </option>
                    <option
                      value="90-days-province"
                    >
                      90 days same Provinces
                    </option>
                    <option
                      value="90-days-location"
                    >
                      90 days same Locations
                    </option>
                  </select>
                </div>
                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group"
                >
                  <label
                    for="compareWith"
                    class="control-label"
                  >Compare with:</label>
                  <select
                    class="custom-select form-control m-input--solid"
                    v-model="compareWith"
                    id="compareWith"
                    @change="changedCompareWith"
                  >
                    <option value="">
                      None
                    </option>
                    <option
                      value="global"
                      v-if="this.params.Logins.length > 0"
                    >
                      Global
                    </option>
                    <option
                      value="globalsameprovince"
                      v-if="this.params.Logins.length > 0"
                    >
                      Global Same Province
                    </option>
                    <option
                      value="globalsamelocation"
                      v-if="this.params.Logins.length > 0"
                    >
                      Global Same Location
                    </option>
                    <option
                      value="customdates"
                    >
                      Custom Dates
                    </option>
                  </select>
                </div>
                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group"
                >
                  <label
                    v-if="compareWith == 'customdates'"
                    for="compareFromDate"
                    class="control-label"
                  >Compare From Date:</label>
                  <input
                    v-if="compareWith == 'customdates'"
                    type="date"
                    class="form-control m-input  m-input--solid"
                    id="compareFromDate"
                    placeholder="Compare From Date"
                    required
                    v-model="compareFromDate"
                    min="2016-04-01"
                  >
                </div>
                <div
                  class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group"
                >
                  <label
                    for="compareToDate"
                    class="control-label"
                    v-if="compareWith == 'customdates'"
                  >Compare To Date:</label>
                  <input
                    v-if="compareWith == 'customdates'"
                    type="date"
                    class="form-control m-input  m-input--solid"
                    id="compareToDate"
                    placeholder="Compare To Date"
                    required
                    v-model="compareToDate"
                    min="2016-04-01"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group" />
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    for="Offer"
                    class="control-label"
                  >Type: <span class="small">(multiple
                    selection)</span>:</label>
                  <v-select
                    :options="propertyTypes"
                    multiple
                    v-model="params.Types"
                    :get-option-label="option => option.Labels['en']"
                    placeholder="Select"
                    class="custom-select form-control noclose"
                  />
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    for="Offer"
                    class="control-label"
                  >Group: <span class="small">(multiple
                    selection)</span>:</label>
                  <v-select
                    :options="propertyGroups"
                    multiple
                    v-model="params.Groups"
                    placeholder="Select"
                    class="custom-select form-control noclose"
                  />
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Property Id:</label>
                  <input
                    type="text"
                    class="form-control"
                    id="id"
                    v-model="params.Id"
                    placeholder="e.g. 7856421"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Agent ref:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="params.AgentRef"
                    placeholder="e.g. agent-ref"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Min price:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.number="params.MinPrice"
                    placeholder="e.g 100000"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Max price:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.number="params.MaxPrice"
                    placeholder="e.g 100000"
                  >
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Bedrooms:</label>
                  <select
                    v-model="params.Bedrooms"
                    class="form-control"
                  >
                    <option value="">
                      Any
                    </option>
                    <option value="1">
                      1
                    </option>
                    <option value="1+">
                      1+
                    </option>
                    <option value="2">
                      2
                    </option>
                    <option value="2+">
                      2+
                    </option>
                    <option value="3">
                      3
                    </option>
                    <option value="3+">
                      3+
                    </option>
                    <option value="4">
                      4
                    </option>
                    <option value="4+">
                      4+
                    </option>
                    <option value="5">
                      5
                    </option>
                    <option value="5+">
                      5+
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Bathrooms:</label>
                  <select
                    v-model="params.Bathrooms"
                    class="form-control"
                  >
                    <option value="">
                      Any
                    </option>
                    <option value="1">
                      1
                    </option>
                    <option value="1+">
                      1+
                    </option>
                    <option value="2">
                      2
                    </option>
                    <option value="2+">
                      2+
                    </option>
                    <option value="3">
                      3
                    </option>
                    <option value="3+">
                      3+
                    </option>
                    <option value="4">
                      4
                    </option>
                    <option value="4+">
                      4+
                    </option>
                    <option value="5">
                      5
                    </option>
                    <option value="5+">
                      5+
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Location:</label>
                  <v-select
                    @search="suggestLocations"
                    :filterable="false"
                    :options="suggestedLocations"
                    :get-option-label="option => option.DisplayName"
                    v-model="params.Location"
                    placeholder="e.g Denia"
                    class="custom-select form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Language:</label>
                  <select
                    v-model="params.Language"
                    class="form-control"
                  >
                    <option
                      v-for="language in languages"
                      :value="language.code"
                      :key="language.code"
                    >
                      {{ language.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Device:</label>
                  <select
                    v-model="params.Device"
                    class="form-control"
                  >
                    <option value="">
                      Any
                    </option>
                    <option value="mobile">
                      Mobile
                    </option>
                    <option value="tablet">
                      Tablet
                    </option>
                    <option value="desktop">
                      Desktop
                    </option>
                    <option value="smarttv">
                      Smart TV
                    </option>
                    <option value="robot">
                      Bot
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Country:</label>
                  <select
                    v-model="params.Country"
                    class="form-control"
                  >
                    <option
                      v-for="country in countries"
                      :value="country.code"
                      :key="country.code"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    for="Offer"
                    class="control-label"
                  >Offer Type:</label>
                  <select
                    class="custom-select form-control m-input--solid"
                    v-model.number="params.Offer"
                    id="offer"
                  >
                    <option value="0">
                      Any
                    </option>
                    <option value="3">
                      For Sale
                    </option>
                    <option value="4">
                      For Rent
                    </option>
                    <option value="2">
                      For Holidays
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label class="control-label">Select ad info:</label>
                  <v-select
                    multiple
                    required
                    :taggable="true"
                    :searchable="true"
                    v-model="params.AdInfo"
                    chips
                    placeholder="Select adevertisement option"
                    class="custom-select form-control noclose"
                    :select-on-key-codes="[188, 13]"
                    :options="adInfoOptions"
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="false"
                        v-bind="attributes"
                        v-on="events"
                      >
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div
      class="row mt-3"
      v-if="searchCalled"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="col-xl-10 col-lg-8 col-md-9 col-sm-9"
                id="metricSelection"
              >
                <div class="form-inline">
                  <label
                    for="metric1"
                    class="control-label mr-2"
                  >View metrics:</label>
                  <select
                    id="metric1"
                    v-model="params.Metric"
                    class="form-control"
                    @change="changedMetrics"
                  >
                    <option
                      v-for="metric in metrics"
                      :key="metric.value"
                      :value="metric.value"
                    >
                      {{ metric.text }}
                    </option>
                  </select>
                  <label
                    for="metric2"
                    class="control-label mx-2"
                  >vs</label>
                  <select
                    id="metric2"
                    class="form-control"
                    v-model="params.Metric2"
                    @change="changedMetrics"
                  >
                    <option
                      v-for="metric in metrics"
                      :key="metric.value"
                      :value="metric.value"
                    >
                      {{ metric.text }}
                    </option>
                  </select>
                  <label
                    for="interval"
                    class="control-label mx-2"
                    v-if="!this.useV2Endpoints"
                  >By</label>
                  <select
                    class="form-control"
                    id="interval"
                    v-model="params.Interval"
                    @change="changedInterval"
                    name="IntervalSelection.Interval"
                    v-if="!this.useV2Endpoints"
                  >
                    <option
                      v-for="interval in intervals"
                      :key="interval.value"
                      :value="interval.value"
                    >
                      {{ interval.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-xl-2 col-lg-4 col-md-3 col-sm-3"
                style="text-align: right;"
              >
                <a
                  class="pull-right"
                  @click.prevent.stop="exportData"
                  style="cursor:pointer"
                  v-if="!this.useV2Endpoints"
                >
                  <span>
                    <i class="la la-download" />
                    <span>Export to Excel</span>
                  </span>
                </a>
              </div>
            </div>
            <h3>
              Metrics
            </h3>
            <div
              id="PropertyChart"
              :ref="'chart'"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="row mt-3"
      v-if="searchCalled"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <div
                  class="panel panel-default"
                  id="dimentions"
                >
                  <div class="panel-heading">
                    <h3 class="panel-title my-5">
                      Dimensions
                    </h3>
                  </div>
                  <div class="panel-body">
                    <div class="form-inline">
                      <label
                        for="dimention1"
                        class="control-label mr-2"
                      >Select dimension:</label>
                      <select
                        id="dimension"
                        class="form-control"
                        v-model="params.Dimention"
                        @change="changedDimensions"
                      >
                        <option
                          value="property"
                          v-if="!this.useV2Endpoints"
                        >
                          Property Id
                        </option>
                        <option
                          value="agentref"
                          v-if="!this.useV2Endpoints"
                        >
                          Agent ref
                        </option>
                        <option value="status">
                          Status
                        </option>
                        <option value="type">
                          Type
                        </option>
                        <option value="bedrooms">
                          Bedrooms
                        </option>
                        <option value="bathrooms">
                          Bathrooms
                        </option>
                        <option value="price">
                          Price
                        </option>
                        <option value="province">
                          Province
                        </option>
                        <option value="region">
                          Region
                        </option>
                        <option value="town">
                          Town
                        </option>
                        <option
                          value="language"
                          selected
                        >
                          Language
                        </option>None
                        <option value="device">
                          Device
                        </option>
                        <option value="country">
                          Country
                        </option>
                      </select>
                    </div>
                    <br>
                    <div>
                      <table
                        id="PropertyTableDim"
                        class="table table-striped table-bordered table-hover with-header-border not-responsive not-collapse sticky-header"
                        style="border: 2px solid #e6e7eb !important"
                      >
                        <thead>
                          <tr>
                            <th
                              rowspan="2"
                            />
                            <th
                              v-if="compareWith"
                              rowspan="2"
                            >
                              Group
                            </th>
                            <th colspan="3">
                              Total
                            </th>

                            <th
                              v-if="this.countOfNoOfPropertiesMetrics < 2"
                              :colspan="3 - this.countOfNoOfPropertiesMetrics"
                            >
                              Standard
                            </th>
                            <th
                              v-if="this.countOfNoOfPropertiesMetrics < 2"
                              :colspan="3 - this.countOfNoOfPropertiesMetrics"
                            >
                              Featured
                            </th>
                            <th
                              v-if="this.countOfNoOfPropertiesMetrics < 2"
                              :colspan="3 - this.countOfNoOfPropertiesMetrics"
                            >
                              Premium
                            </th>
                          </tr>
                          <tr>
                            <th>
                              {{ getMetricTextByValue(params.Metric) }}
                              <i
                                v-if="dimentionSort == 'total' && dimetionMetric == params.Metric && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('total', params.Metric, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'total' && dimetionMetric == params.Metric && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('total', params.Metric, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('total', params.Metric, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'total', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'total', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                            </th>
                            <th>
                              {{ getMetricTextByValue(params.Metric2) }}
                              <i
                                v-if="dimentionSort == 'total' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('total', params.Metric2, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'total' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('total', params.Metric2, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('total', params.Metric2, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'total', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'total', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                            </th>
                            <th>
                              Ratio
                              <i
                                v-if="dimentionSort == 'total' && dimetionMetric == 'ratio' && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('total', 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'total' && dimetionMetric == 'ratio' && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('total', 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('total', 'desc')"
                              />
                            </th>

                            <th>
                              {{ getMetricTextByValue(params.Metric) }}
                              <i
                                v-if="dimentionSort == 'standard' && dimetionMetric == params.Metric && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('standard', params.Metric, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'standard' && dimetionMetric == params.Metric && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('standard', params.Metric, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('standard', params.Metric, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'standard', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'standard', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                            </th>
                            <th>
                              {{ getMetricTextByValue(params.Metric2) }}
                              <i
                                v-if="dimentionSort == 'standard' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('standard', params.Metric2, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'standard' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('standard', params.Metric2, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('standard', params.Metric2, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'standard', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'standard', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                            </th>
                            <th>
                              Ratio
                              <i
                                v-if="dimentionSort == 'standard' && dimetionMetric == 'ratio' && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('standard', 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'standard' && dimetionMetric == 'ratio' && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('standard', 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('standard', 'desc')"
                              />
                            </th>

                            <th>
                              {{ getMetricTextByValue(params.Metric) }}
                              <i
                                v-if="dimentionSort == 'featured' && dimetionMetric == params.Metric && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('featured', params.Metric, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'featured' && dimetionMetric == params.Metric && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('featured', params.Metric, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('featured', params.Metric, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'featured', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'featured', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                            </th>
                            <th>
                              {{ getMetricTextByValue(params.Metric2) }}
                              <i
                                v-if="dimentionSort == 'featured' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('featured', params.Metric2, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'featured' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('featured', params.Metric2, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('featured', params.Metric2, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'featured', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'featured', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                            </th>
                            <th>
                              Ratio
                              <i
                                v-if="dimentionSort == 'featured' && dimetionMetric == 'ratio' && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('featured', 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'featured' && dimetionMetric == 'ratio' && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('featured', 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('featured', 'desc')"
                              />
                            </th>

                            <th>
                              {{ getMetricTextByValue(params.Metric) }}
                              <i
                                v-if="dimentionSort == 'premium' && dimetionMetric == params.Metric && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('premium', params.Metric, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'premium' && dimetionMetric == params.Metric && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('premium', params.Metric, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('premium', params.Metric, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'premium', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'premium', searchParams.Metric, 'Metric1' ) ) }}
                              </span>
                            </th>
                            <th>
                              {{ getMetricTextByValue(params.Metric2) }}
                              <i
                                v-if="dimentionSort == 'premium' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimention('premium', params.Metric2, 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'premium' && dimetionMetric == params.Metric2 && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimention('premium', params.Metric2, 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimention('premium', params.Metric2, 'desc')"
                              />
                              <br
                                v-if="this.totals"
                              >
                              <span
                                v-if="this.totals"
                              >
                                {{ formatValueAsNumber( getTotalValueForMetric( 'premium', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                              <span
                                v-if="this.totals && compareWith"
                              >
                                vs {{ formatValueAsNumber( getTotalCompareValueForMetric( 'premium', searchParams.Metric2, 'Metric2' ) ) }}
                              </span>
                            </th>
                            <th>
                              Ratio
                              <i
                                v-if="dimentionSort == 'premium' && dimetionMetric == 'ratio' && dimentionSortOrder == 'desc'"
                                class="jam jam-arrow-down"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('premium', 'asc')"
                              />
                              <i
                                v-else-if="dimentionSort == 'premium' && dimetionMetric == 'ratio' && dimentionSortOrder == 'asc'"
                                class="jam jam-arrow-up"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('premium', 'desc')"
                              />
                              <i
                                v-else
                                class="jam jam-arrows-v"
                                style="cursor: pointer;"
                                @click="sortDimentionRatio('premium', 'desc')"
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-if="rows.length == 0">
                            <tr>
                              <td
                                colspan="15"
                                class="text-center m--regular-font-size-lg3 py-3"
                              >
                                No results
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <template
                              v-for="(row, index) in rows"
                            >
                              <tr
                                :key="index"
                              >
                                <td
                                  class="ws-nowrap m--font-bolder"
                                  v-if="searchParams.Dimention == 'property'"
                                  :rowspan="compareWith ? 3 : 1"
                                >
                                  <a
                                    href="javascript:;"
                                    @click.stop.prevent="openPropertyPopup(row.Group, $event)"
                                    :id="'propertyInfo_' + row.Group"
                                  >
                                    {{ row.GroupDescription ? row.GroupDescription :
                                      row.Group }}
                                  </a>
                                </td>
                                <td
                                  class="ws-nowrap m--font-bolder"
                                  v-else
                                  :rowspan="compareWith ? 3 : 1"
                                >
                                  {{ row.GroupDescription ? row.GroupDescription : row.Group
                                  }}
                                </td>
                                <td
                                  v-if="compareWith"
                                  class="ws-nowrap m--font-bolder"
                                >
                                  {{ compareOnText }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row, 'total', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row, 'total', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row, 'total', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row, 'standard', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row, 'standard', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row, 'standard', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row, 'featured', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row, 'featured', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row, 'featured', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row, 'premium', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row, 'premium', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row, 'premium', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                              </tr>
                              <tr
                                v-if="compareWith"
                                :key="'global_' + index"
                              >
                                <td
                                  class="ws-nowrap m--font-bolder"
                                >
                                  {{ compareWithText }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row.Compare, 'total', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row.Compare, 'total', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row.Compare, 'total', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row.Compare, 'standard', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row.Compare, 'standard', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row.Compare, 'standard', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row.Compare, 'featured', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row.Compare, 'featured', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row.Compare, 'featured', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForFirstMetric(row.Compare, 'premium', searchParams.Metric) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionValueForSecondMetric(row.Compare, 'premium', searchParams.Metric2) )
                                  }}
                                </td>
                                <td>
                                  {{
                                    formatValueAsNumber( getDimentionRatio(row.Compare, 'premium', searchParams.Metric, searchParams.Metric2) )
                                  }}
                                </td>
                              </tr>
                              <tr
                                v-if="compareWith"
                                :key="'globalcompare_' + index"
                              >
                                <td
                                  class="ws-nowrap m--font-bolder"
                                >
                                  {{ searchCompareWith == 'customdates' ? 'Change' : 'Ratio' }}
                                </td>
                                <td>
                                  {{
                                    getDimentionRatioForComparisonFirstAsRatioOrChange( row, 'total', searchParams.Metric )
                                  }}
                                </td>
                                <td>
                                  {{
                                    getDimentionRatioForComparisonSecondAsRatioOrChange( row, 'total', searchParams.Metric )
                                  }}
                                </td>
                                <td />
                                <td>
                                  {{
                                    getDimentionRatioForComparisonFirstAsRatioOrChange( row, 'standard', searchParams.Metric )
                                  }}
                                </td>
                                <td>
                                  {{
                                    getDimentionRatioForComparisonSecondAsRatioOrChange( row, 'standard', searchParams.Metric2 )
                                  }}
                                </td>
                                <td />
                                <td>
                                  {{
                                    getDimentionRatioForComparisonFirstAsRatioOrChange( row, 'featured', searchParams.Metric )
                                  }}
                                </td>
                                <td>
                                  {{
                                    getDimentionRatioForComparisonSecondAsRatioOrChange( row, 'featured', searchParams.Metric2 )
                                  }}
                                </td>
                                <td />
                                <td>
                                  {{
                                    getDimentionRatioForComparisonFirstAsRatioOrChange( row, 'premium', searchParams.Metric )
                                  }}
                                </td>
                                <td>
                                  {{
                                    getDimentionRatioForComparisonSecondAsRatioOrChange( row, 'premium', searchParams.Metric )
                                  }}
                                </td>
                                <td />
                              </tr>
                            </template>
                          </template>
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      :total-pages="pagination.totalPages"
                      :total="pagination.totalResults || 0"
                      :per-page="pagination.Take"
                      :loading="false"
                      :current-page="pagination.currentPage"
                      :target-scroll-y="'dimension'"
                      @pagechanged="onPageChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN::Property Info Popover -->
    <div
      class="d-none"
      id="popoverInfo"
    >
      <div
        class="row"
        v-if="selectedProperty"
      >
        <div class="col-4 pr-0">
          <div class="thumbnailTableContainer">
            <div class="ratio-4-3-padding">
              <a
                :href="getPropertyURL"
                target="_blank"
              >

                <div class="d-none broken-img">
                  <span class="img-cont">
                    <i class="la la-warning m--icon-font-size-lg3 d-block" />
                    <span class="d-block small">Broken images</span>
                  </span>
                </div>

                <img
                  width="100%"
                  alt=""
                  ref="propertyInfoImage"
                  :src="getFirstPhotoUrl"
                  data-img="false"
                >
              </a>
            </div>
          </div>
        </div>
        <div class="col">
          <h6>
            <a
              :href="getPropertyURL"
              target="_blank"
            >
              {{ getPropertyTypeTextById(selectedProperty.Type.Id) }} {{ selectedProperty.Town.Labels.Default }}
              ({{ selectedProperty.Town.Labels.province.Default }})
            </a>
          </h6>
          <p v-if="selectedProperty.PriceInEuro">
            {{ formatPrice( selectedProperty.PriceInEuro, 'EUR' ) }}
          </p>
          <p v-if="selectedProperty.PriceInPounds">
            {{ formatPrice( selectedProperty.PriceInPounds, 'GBP' ) }}
          </p>
        </div>
        <div class="clearfix" />
      </div>
    </div>

    <div
      class="d-none"
      id="propertyhistory"
    >
      <div
        class="row"
        v-for="(property, index) in propertyhistory"
        :key="index"
      >
        <div class="col-4 pr-0">
          <a
            :href="'https://www.thinkspain.com/en/redirect-to-property/' + property.Id"
            target="_blank"
            class="d-block"
          >{{ property.Id }}</a>
        </div>
        <div class="col">
          <h6>{{ 'From: ' + formatToDate(property.FromDate) }}</h6>
          <h6>{{ 'To: ' + formatToDate(property.ToDate) }}</h6>
          <p>{{ formatPrice( property.Price, property.Currency ) }}</p>
        </div>
        <div class="clearfix" />
      </div>
      <div
        class="row text-center"
        v-if="!propertyhistory || propertyhistory.length == 0"
      >
        <div class="col">
          No History entry found
        </div>
      </div>
    </div>
    <div
      :class="`modal fade px-0 ${viewReportContent ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
        style="max-width: 900px;"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ (this.report != null && this.report.endsWith( '-es' ) ) ? 'INFORME PARA LOGIN' : 'Report for login' }} ({{ params.Logins.join( ', ' ) }})
            </h5>
            <button
              type="button"
              class="close"
              @click="viewReportContent = false;"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="modal-body container-fluid"
          >
            <div
              v-html="reportContent"
            />
            <div
              class="input-group-append"
              style="padding: 10px 0;"
            >
              <button
                class="btn btn-success"
                type="button"
                @click="copyToClipboard"
              >
                {{ (this.report != null && this.report.endsWith( '-es' ) ) ? 'Copiar texto al portapapeles' : 'Copy text to clipboard' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import collections from '../../../../../collections';
import clientanalyticsapi from '../../../../../clientanalyticsapi';
import adminapi from '../../../../../http';
import locationsapi from '../../../../../locationsapi';
import notify from '../../../../../notifications';
import dayjs from 'dayjs';
import Pagination from './pagination.vue';

export default {
    components: {
        Pagination
    },
    data() {
        return {
            user: {},
            report: '',
            reportContent: '',
            viewReportContent: false,
            propertyService: null,
            countries: {},
            languages: {},
            metrics: [
                { value: 'views', text: 'Views' },
                { value: 'search', text: 'Search Results' },
                { value: 'detailed', text: 'Detailed Views' },
                { value: 'enquiries', text: 'Enquiries' },
                {
                    value: 'noofproperties',
                    text: 'Avg Number of Properties Listed'
                },
                {
                    value: 'noofagents',
                    text: 'Number of Agents Listed'
                },
                {
                    value: 'uniquelistedproperties',
                    text: 'Number of Properties Listed'
                },
                {
                    value: 'avgprice',
                    text: 'Average Price'
                }
            ],
            intervals: [
                { value: 'day', text: 'Day' },
                { value: 'week', text: 'Week' },
                { value: 'month', text: 'Month' }
            ],
            dimentionSort: '',
            dimetionMetric: '',
            dimentionSortOrder: '',
            searchCalled: false,
            selectedProperty: null,
            propertyhistory: null,
            showPropInfo: false,
            propertyInfo: null,
            propertyInfoPhoto: null,
            dateText: 'Date',
            url: process.env.API_URL,
            pagination: {
                Take: process.env.TAKE_ROWS,
                Skip: 0,
                totalPages: 0,
                totalResults: 0,
                currentPage: 1
            },
            resultsPerPage: 20,
            suggestedLocations: [],
            propertyTypes: [],
            adInfoOptions: [
                {
                    label: 'Featured',
                    value: 'featured'
                },
                {
                    label: 'Featured Premium',
                    value: 'featured-premium'
                }
            ],
            propertyGroups: [
                {
                    value: 'houses-and-apartments',
                    label: 'Houses and Apartments'
                },
                {
                    value: 'plots-lands-ruins',
                    label: 'Plots of Land and Ruins'
                },
                {
                    value: 'business-commercial',
                    label: 'Business and Commercial'
                },
                {
                    value: 'garages',
                    label: 'Garages and Parking'
                }
            ],
            selectedLanguage: null,
            saw: null,
            locationOptions: [],
            URL: process.env.API_URL,
            range: 30,
            rows: [],
            totals: null,
            compareWith: '',
            compareFromDate: dayjs().tz().subtract( 60, 'days' ).format( 'YYYY-MM-DD' ),
            compareToDate: dayjs().tz().subtract( 31, 'days' ).format( 'YYYY-MM-DD' ),
            searchCompareWith: '',
            searchCompareFromDate: dayjs().tz().subtract( 60, 'days' ).format( 'YYYY-MM-DD' ),
            searchCompareToDate: dayjs().tz().subtract( 31, 'days' ).format( 'YYYY-MM-DD' ),
            params: {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
                Dimention: 'status',
                Metric: 'views',
                Metric2: 'enquiries',
                Interval: 'day',
                Offer: 0,
                Types: [],
                Groups: [],
                Id: '',
                AgentRef: '',
                MinPrice: null,
                MaxPrice: null,
                Bathrooms: '',
                Bedrooms: '',
                Location: null,
                Language: '',
                Device: '',
                Country: '',
                Logins: [],
                AdInfo: []
            },
            searchParams: {},
            chartData: {},
            chartOptions: {}
        };
    },
    created() {
        window.addEventListener( 'resize', this.reDrawChart );
    },
    destroyed() {
        window.removeEventListener( 'resize', this.reDrawChart );
    },
    async mounted() {
        if ( this.$route.query.login )
            this.params.Logins = Array.isArray( this.$route.query.login ) ? this.$route.query.login : [ this.$route.query.login ];

        if ( this.$route.query.fromdate )
            this.params.FromDate = this.$route.query.fromdate;

        if ( this.$route.query.metric )
            this.params.Metric = this.$route.query.metric;

        if ( this.$route.query.metric2 )
            this.params.Metric2 = this.$route.query.metric2;

        let byName = function( c1, c2 ) {
            var name1 = c1.name.toUpperCase();
            var name2 = c2.name.toUpperCase();
            if ( name1 < name2 ) {
                return -1;
            }
            if ( name1 > name2 ) {
                return 1;
            }
            return 0;
        };

        let listOfCounries = collections
            .countries()
            .map( ( country ) => {
                return { code: country.Code, name: country.Labels[ 'en' ] };
            } )
            .sort( byName );
        listOfCounries.unshift( { code: '', name: 'Select' } );
        this.countries = listOfCounries;

        let listOfLanguages = collections
            .languages()
            .map( ( language ) => {
                return { code: language.code, name: language.Labels[ 'en' ] };
            } )
            .sort( byName );
        listOfLanguages.unshift( { code: '', name: 'Select' } );
        this.languages = listOfLanguages;

        this.propertyTypes = collections.propertyTypes();
        this.loadExternalScripts();
    },
    computed: {
        compareOnText() {
            if ( this.searchCompareWith == 'customdates' ) {
                return `${ this.searchParams.FromDate } - ${ this.searchParams.ToDate }`;
            }

            return this.searchParams.Logins.join( ', ' );
        },
        compareWithText() {
            if ( !this.searchCompareWith ) {
                return '';
            }

            if ( this.searchCompareWith == 'global' ) {
                return 'Global';
            }

            if ( this.searchCompareWith == 'globalsameprovince' ) {
                return 'Global (Same Province)';
            }

            if ( this.searchCompareWith == 'globalsamelocation' ) {
                return 'Global (Same Location)';
            }

            if ( this.searchCompareWith == 'customdates' ) {
                return `${ this.searchCompareFromDate } - ${ this.searchCompareToDate }`;
            }

            return 'Total';
        },
        countOfNoOfPropertiesMetrics() {
            return 0;
        },
        getPropertyId() {
            if ( this.propertyInfo !== null ) return this.propertyInfo.Id;

            return 'xx';
        },
        getPropertyURL() {
            if ( this.selectedProperty !== null )
                return 'https://www.thinkspain.com/en/redirect-to-property/' + this.selectedProperty.Id;

            return '';
        },
        getFirstPhotoUrl() {
            let property = this.selectedProperty;

            let photos = property.Photos.filter( ( p ) => p.CdnUrl );

            if ( !photos || photos.length == 0 ) {
                return null;
            }

            let photo = photos[ 0 ];

            for ( let p of photos ) {
                if ( p.Number < photo.Number ) {
                    photo = p;
                }
            }

            let urlChunks = photo.CdnUrl.split( '/' );

            if ( urlChunks.length < 3 ) {
                return '';
            }

            urlChunks.splice( urlChunks.length - 1, 0, 's400x300' );

            return urlChunks.join( '/' );
        }
    },
    methods: {
        async copyToClipboard() {
            // copy to clipboard but replace all <br>, <br/>, <br /> with \n

            let reportContentCleaned = this.reportContent.replace( /<br\s*\/?>/gi, '\n' );
            await navigator.clipboard.writeText( reportContentCleaned );
            notify( {
                title: 'Copied',
                text: 'Report has been copied to clipboard',
                type: 'success'
            } );
        },
        async generateReport( ) {
            if ( this.report == '' ) {
                return;
            }

            this.appLoading( true );
            let reportRequest = await clientanalyticsapi.post( '/report', {
                logins: this.params.Logins,
                report: this.report
            } );
            this.appLoading( false );

            if ( reportRequest.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            // read content
            this.reportContent = await reportRequest.text();

            this.viewReportContent = true;
        },
        sortDimentionRatio( sort, order ) {
            this.dimentionSort = sort;
            this.dimetionMetric = 'ratio';
            this.dimentionSortOrder = order;

            this.rows.sort( ( a, b ) => {
                let value1 = this.getDimentionRatio( a, sort, this.searchParams.Metric, this.searchParams.Metric2 );
                let value2 = this.getDimentionRatio( b, sort, this.searchParams.Metric, this.searchParams.Metric2 );

                if ( order == 'asc' ) {
                    return value1 - value2;
                }

                return value2 - value1;
            } );
        },
        sortDimention( sort, metric, order ) {
            this.dimentionSort = sort;
            this.dimetionMetric = metric;
            this.dimentionSortOrder = order;

            this.rows.sort( ( a, b ) => {
                // if this is first metric, then call: this.getDimentionValueForFirstMetric
                // if this is second metric, then call: this.getDimentionValueForSecondMetric

                let value1 = 0;
                let value2 = 0;

                if ( metric == this.searchParams.Metric ) {
                    value1 = this.getDimentionValueForFirstMetric( a, sort, metric );
                    value2 = this.getDimentionValueForFirstMetric( b, sort, metric );
                } else {
                    value1 = this.getDimentionValueForSecondMetric( a, sort, metric );
                    value2 = this.getDimentionValueForSecondMetric( b, sort, metric );
                }

                // Ensure values are numbers
                value1 = isNaN( value1 ) ? 0 : Number( value1 );
                value2 = isNaN( value2 ) ? 0 : Number( value2 );

                if ( order == 'asc' ) {
                    return value1 - value2;
                }

                return value2 - value1;
            } );
        },

        formatValueAsNumber( number ) {
            // check if number is not a number - then return as is
            // if there is a number - retrurn with thousand separator
            if ( isNaN( number ) ) {
                return number;
            }

            return number.toLocaleString( 'en-US', { maximumFractionDigits: 2, useGrouping: 'always' } );
        },
        getDimentionRatioForComparisonFirstAsRatioOrChange( row, field, metric ) {
            let value1 = this.getDimentionValueForFirstMetric( row, field, metric );
            let value2 = this.getDimentionValueForFirstMetric( row.Compare, field, metric );

            if ( value1 == 'N/A' || value2 == 'N/A' ) {
                return 'N/A';
            }

            if ( value1 == 0 && value2 == 0 ) {
                return '0%';
            }

            if ( this.searchCompareWith == 'customdates' ) {
                if ( value2 == 0 ) {
                    return '∞%';
                }
                const percentageChange = ( ( value1 - value2 ) / value2 );
                return this.formatValueAsPercentage( percentageChange );
            }

            if ( value1 == 0 ) {
                return '0%';
            }

            const ratio = value1 / value2;
            return this.formatValueAsPercentage( ratio );
        },
        getDimentionRatioForComparisonSecondAsRatioOrChange( row, field, metric ) {
            let value1 = this.getDimentionValueForSecondMetric( row, field, metric );
            let value2 = this.getDimentionValueForSecondMetric( row.Compare, field, metric );

            if ( value1 == 'N/A' || value2 == 'N/A' ) {
                return 'N/A';
            }

            if ( value1 == 0 && value2 == 0 ) {
                return '0%';
            }

            if ( this.searchCompareWith == 'customdates' ) {
                if ( value2 == 0 ) {
                    return '∞%';
                }
                const percentageChange = ( ( value1 - value2 ) / value2 );
                return this.formatValueAsPercentage( percentageChange );
            }

            if ( value1 == 0 ) {
                return '0%';
            }

            const ratio = value1 / value2;
            return this.formatValueAsPercentage( ratio );
        },
        formatValueAsPercentage( number ) {
            // check if number is not a number - then return as is
            // if there is a number - retrurn with thousand separator
            if ( isNaN( number ) ) {
                return number;
            }

            return number.toLocaleString( 'en-US', { maximumFractionDigits: 2, style: 'percent' } );
        },
        getTotalValueForMetric( field, metric, metricName ) {
            var systemMetrics = [ 'noofproperties', 'noofagents', 'uniquelistedproperties', 'avgprice' ];

            // dimention device, country
            if ( [ 'country', 'device' ].includes( this.searchParams.Dimention ) && systemMetrics.includes( metric ) ) {
                return 'N/A';
            }

            let row = this.totals;

            if ( field == 'total' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Total[ metricName ];
                }

                return row.thinkspain.Total[ metricName ];
            }

            if ( field == 'standard' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Standard[ metricName ];
                }

                return row.thinkspain.Standard[ metricName ];
            }

            if ( field == 'featured' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Featured[ metricName ];
                }

                return row.thinkspain.Featured[ metricName ];
            }

            if ( field == 'premium' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Premium[ metricName ];
                }

                return row.thinkspain.Premium[ metricName ];
            }

            return 0;
        },
        getTotalCompareValueForMetric( field, metric, metricName ) {
            let systemMetrics = [ 'noofproperties', 'noofagents', 'uniquelistedproperties', 'avgprice' ];
            // dimention device, country
            if ( [ 'country', 'device' ].includes( this.searchParams.Dimention ) && systemMetrics.includes( metric ) ) {
                return 'N/A';
            }

            let row = this.totals.Compare;

            if ( field == 'total' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Total[ metricName ];
                }

                return row.thinkspain.Total[ metricName ];
            }

            if ( field == 'standard' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Standard[ metricName ];
                }

                return row.thinkspain.Standard[ metricName ];
            }

            if ( field == 'featured' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Featured[ metricName ];
                }

                return row.thinkspain.Featured[ metricName ];
            }

            if ( field == 'premium' ) {
                if ( systemMetrics.includes( metric ) ) {
                    return row.Premium[ metricName ];
                }

                return row.thinkspain.Premium[ metricName ];
            }

            return 0;
        },
        getDimentionValueForFirstMetric( row, field, metric ) {
            let systemMetrics = [ 'noofproperties', 'noofagents', 'uniquelistedproperties', 'avgprice' ];

            if ( [ 'country', 'device' ].includes( this.searchParams.Dimention ) && systemMetrics.includes( metric ) ) {
                return 'N/A';
            }

            if ( field == 'total' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Total.Metric1;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Total.Metric1;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Total.Metric1;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Total.Metric1;
                }

                return row.thinkspain.Total.Metric1;
            }

            if ( field == 'standard' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Standard.Metric1;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Standard.Metric1;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Standard.Metric1;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Standard.Metric1;
                }

                return row.thinkspain.Standard.Metric1;
            }

            if ( field == 'featured' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Featured.Metric1;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Featured.Metric1;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Featured.Metric1;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Featured.Metric1;
                }

                return row.thinkspain.Featured.Metric1;
            }

            if ( field == 'premium' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Premium.Metric1;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Premium.Metric1;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Premium.Metric1;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Premium.Metric1;
                }

                return row.thinkspain.Premium.Metric1;
            }

            return 0;
        },
        // field (total, standard, featured, premium)
        // metric (noofproperties, noofagents, uniquelistedproperties, views, enquiries, views, detailed)
        getDimentionValueForSecondMetric( row, field, metric ) {
            // dimention device, country, language
            if ( [ 'country', 'device' ].includes( this.searchParams.Dimention ) && [ 'noofproperties', 'noofagents', 'uniquelistedproperties', 'avgprice' ].includes( metric ) ) {
                return 'N/A';
            }

            if ( field == 'total' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Total.Metric2;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Total.Metric2;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Total.Metric2;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Total.Metric2;
                }

                return row.thinkspain.Total.Metric2;
            }

            if ( field == 'standard' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Standard.Metric2;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Standard.Metric2;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Standard.Metric2;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Standard.Metric2;
                }

                return row.thinkspain.Standard.Metric2;
            }

            if ( field == 'featured' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Featured.Metric2;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Featured.Metric2;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Featured.Metric2;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Featured.Metric2;
                }

                return row.thinkspain.Featured.Metric2;
            }

            if ( field == 'premium' ) {
                if ( metric == 'noofproperties' ) {
                    return row.NoOfProperties.Premium.Metric2;
                }

                if ( metric == 'noofagents' ) {
                    return row.NoOfAgents.Premium.Metric2;
                }

                if ( metric == 'uniquelistedproperties' ) {
                    return row.UniqueListedProperties.Premium.Metric2;
                }

                if ( metric == 'avgprice' ) {
                    return row.AvgPrice.Premium.Metric2;
                }

                return row.thinkspain.Premium.Metric2;
            }

            return 0;
        },
        getDimentionRatioForComparisonFirst( row, field, metric ) {
            let value1 = this.getDimentionValueForFirstMetric( row, field, metric );
            let value2 = this.getDimentionValueForFirstMetric( row.Compare, field, metric );

            if ( this.searchCompareWith == 'customdates' ) {
                value1 = this.getDimentionValueForFirstMetric( row.Compare, field, metric );
                value2 = this.getDimentionValueForFirstMetric( row, field, metric );
            }

            if ( value1 == 'N/A' || value2 == 'N/A' ) {
                return 'N/A';
            }

            if ( value2 == 0 ) {
                return 0;
            }

            return value1 / value2;
        },
        getDimentionRatioForComparisonSecond( row, field, metric ) {
            let value1 = this.getDimentionValueForSecondMetric( row, field, metric );
            let value2 = this.getDimentionValueForSecondMetric( row.Compare, field, metric );

            if ( this.searchCompareWith == 'customdates' ) {
                value1 = this.getDimentionValueForSecondMetric( row.Compare, field, metric );
                value2 = this.getDimentionValueForSecondMetric( row, field, metric );
            }

            if ( value1 == 'N/A' || value2 == 'N/A' ) {
                return 'N/A';
            }

            if ( value2 == 0 ) {
                return 0;
            }

            return value1 / value2;
        },
        getDimentionRatio( row, field, metric1, metric2 ) {
            let value1 = this.getDimentionValueForFirstMetric( row, field, metric1 );
            let value2 = this.getDimentionValueForSecondMetric( row, field, metric2 );

            if ( value1 == 'N/A' || value2 == 'N/A' ) {
                return 'N/A';
            }

            if ( value2 == 0 ) {
                return 0;
            }

            return value1 / value2;
        },
        getMetricTextByValue( value ) {
            let metric = this.metrics.filter( ( m ) => m.value == value );

            if ( !metric ) {
                return '';
            }

            return metric[ 0 ].text;
        },
        formatPrice( price, currency ) {
            if ( !price ) {
                return '';
            }

            // get current browser locale
            let locale = navigator.language || navigator.userLanguage;

            return price.toLocaleString( locale, {
                style: 'currency',
                currency: currency
            } );
        },
        getPropertyTypeTextById( typeId ) {
            let propertyType = this.propertyTypes.filter( ( pt ) => pt.Id == typeId );

            if ( !propertyType ) {
                return '';
            }

            return propertyType[ 0 ].Labels[ 'en' ];
        },
        formatToDate( input ) {
            return dayjs( input ).tz().format( 'DD/MM/YYYY' );
        },
        async openPropertyPopup( propertyId, event ) {
            this.appLoading( true );
            let propertyResponse = await adminapi.get( '/property/' + propertyId );

            if ( propertyResponse.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            this.selectedProperty = ( await propertyResponse.json() );

            await this.$nextTick();

            let myPopover = $( event.target ).popover( {
                trigger: 'focus',
                title: 'Ref: ' + this.selectedProperty.AgentRef,
                placement: 'auto',
                content: document.getElementById( 'popoverInfo' ).innerHTML,
                html: true
            } );

            myPopover.popover( 'show' );

            myPopover.on( 'shown.bs.popover', function() {
                let popupcontent = document.getElementById(
                    event.target.getAttribute( 'aria-describedby' )
                );
                if ( !popupcontent ) {
                    return;
                }
                let closeBtn = popupcontent.querySelector( '.close-popover' );
                if ( !closeBtn ) {
                    return;
                }

                closeBtn.addEventListener( 'click', function() {
                    myPopover.popover( 'dispose' );
                } );
            } );
        },
        async openPropertyHistory( agentRef, event ) {
            $( '.popover.show' ).popover( 'hide' );

            let request = {
                AgentRef: agentRef,
                FromDate: dayjs( this.searchParams.FromDate ).tz().format(),
                ToDate: dayjs( this.searchParams.ToDate ).tz().format(),
                Logins: this.searchParams.Logins
            };
            let propertyResponse = await clientanalyticsapi.post( '/propertyhistory', request );

            if ( propertyResponse.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            this.propertyhistory = await propertyResponse.json();

            await this.$nextTick();

            let myPopover = $( event.target ).popover( {
                trigger: 'focus',
                title: 'Ref: ' + agentRef,
                placement: 'auto',
                content: document.getElementById( 'propertyhistory' ).innerHTML,
                html: true
            } );

            myPopover.popover( 'show' );

            myPopover.on( 'shown.bs.popover', function() {
                let popupcontent = document.getElementById(
                    event.target.getAttribute( 'aria-describedby' )
                );
                if ( !popupcontent ) {
                    return;
                }
                let closeBtn = popupcontent.querySelector( '.close-popover' );
                if ( !closeBtn ) {
                    return;
                }

                closeBtn.addEventListener( 'click', function() {
                    myPopover.popover( 'dispose' );
                } );
            } );
        },
        async suggestLocations( search, loading ) {
            if ( search.length <= 2 ) {
                return;
            }
            loading( true );

            let result = await locationsapi.get( `/location?freetext=${ encodeURIComponent( search ) }&lang=en` );

            loading( false );

            if ( result.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            this.suggestedLocations = ( await result.json() );
        },
        loadExternalScripts() {
            let component = this;
            let googleChartScripts = document.createElement( 'script' );
            googleChartScripts.onload = () => {
                component.externalScriptsLoaded();
            };
            googleChartScripts.setAttribute(
                'src',
                'https://www.gstatic.com/charts/loader.js'
            );
            document.head.appendChild( googleChartScripts );
        },
        externalScriptsLoaded() {
            let component = this;
            google.charts.load( 'current', { packages: [ 'corechart', 'line' ] } );
            google.charts.setOnLoadCallback( function() {
                if ( component.params.Logins.length > 0 ) {
                    component.search();
                }
            } );
        },
        async onPageChange( page ) {
            this.pagination.currentPage = page;
            this.pagination.Skip =
          ( this.pagination.currentPage - 1 ) * this.pagination.Take;
            this.params.Skip = this.pagination.Skip;

            this.appLoading( true );

            await this.queryDimensions();

            this.appLoading( false );
        },
        changedCompareWith() {
            if ( this.compareWith == 'customdates' ) {
                // set previous period to the one from the params
                // e.g. if params.FromDate is 2024-11-01 and params.ToDate is 2024-12-01
                // set customFromDate to 2024-10-01 and customToDate to 2024-11-01
                // if diff is 3 months, then set customFromDate to 2024-09-01, etc
                // if diff is 7 days, then set customFromDate to 2024-10-25, etc
                // use day diff for comparison to make sure number of days in both sets is the same
                let diff = dayjs( this.params.ToDate ).diff( dayjs( this.params.FromDate ), 'days' );

                this.compareFromDate = dayjs( this.params.FromDate ).subtract( diff, 'days' ).format( 'YYYY-MM-DD' );
                this.compareToDate = dayjs( this.params.FromDate ).subtract( 1, 'days' ).format( 'YYYY-MM-DD' );
            }
        },
        changedMetrics() {
            this.rows = [];
            this.totals = null;
            this.dimentionSort = '';
            this.dimetionMetric = '';
            this.dimentionSortOrder = '';
            this.search();
        },
        async changedDimensions() {
            this.rows = [];
            this.totals = null;
            this.dimentionSort = '';
            this.dimetionMetric = '';
            this.dimentionSortOrder = '';
            this.searchParams = JSON.parse( JSON.stringify( this.params ) );
            this.searchCompareWith = this.compareWith;
            this.searchCompareFromDate = this.compareFromDate;
            this.searchCompareToDate = this.compareToDate;

            this.appLoading( true );

            await this.queryDimensions();

            this.appLoading( false );
        },
        async changedInterval() {
            this.rows = [];
            this.totals = null;
            this.dimentionSort = '';
            this.dimetionMetric = '';
            this.dimentionSortOrder = '';
            this.searchParams = JSON.parse( JSON.stringify( this.params ) );
            this.searchCompareWith = this.compareWith;
            this.searchCompareFromDate = this.compareFromDate;
            this.searchCompareToDate = this.compareToDate;

            this.appLoading( true );

            await this.queryMetrics();

            this.appLoading( false );
        },
        async search() {
            this.searchCalled = true;
            this.searchParams = JSON.parse( JSON.stringify( this.params ) );
            this.searchCompareWith = this.compareWith;
            this.searchCompareFromDate = this.compareFromDate;
            this.searchCompareToDate = this.compareToDate;

            this.appLoading( true );

            await Promise.all( [ this.queryMetrics(), this.queryDimensions() ] );

            this.appLoading( false );
        },

        async exportData() {
            let request = {
                filter: this.getFilter(),
                language: 'en',
                metrics: [ this.searchParams.Metric, this.searchParams.Metric2 ],
                dimention: this.searchParams.Dimention,
                interval: this.searchParams.Interval
            };

            let exportResult = await clientanalyticsapi.post( '/property/export', request );

            if ( exportResult.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            let blob = await exportResult.blob();

            const url = window.URL.createObjectURL( blob );
            const link = document.createElement( 'a' );
            link.href = url;
            link.setAttribute( 'download', 'propertyanalytics.xlsx' ); // or any other extension
            document.body.appendChild( link );
            link.click();
        },
        useV2Endpoints() {
            return true;
        },
        getFilter() {
            let filter = {
                datefilter: {
                    fromDate: this.searchParams.FromDate,
                    toDate: this.searchParams.ToDate
                },
                propertyFilter: {
                    offer: this.searchParams.Offer,
                    types: this.searchParams.Types.map( ( type ) => type.Id ),
                    groups: this.searchParams.Groups.map( ( group ) => group.value ),
                    id: this.searchParams.Id,
                    agentRef: this.searchParams.AgentRef,
                    minPrice: this.searchParams.MinPrice,
                    maxPrice: this.searchParams.MaxPrice,
                    location: this.searchParams.Location ? `${this.searchParams.Location.Type}:${this.searchParams.Location.ID}` : null,
                    logins: this.searchParams.Logins,
                    adinfo: this.searchParams.AdInfo.map( ( adinfo ) => adinfo.value )
                },
                viewFilter: {
                    language: this.searchParams.Language,
                    device: this.searchParams.Device,
                    country: this.searchParams.Country,
                    adinfo: this.searchParams.AdInfo.map( ( adinfo ) => adinfo.value ),
                    source: 'thinkspain' // based on #CCP-505 we are no longer going to support EOS
                }
            };

            // bedrooms can be 2, 3 ... or 3+ so we need to break it to bedrooms and minbedrooms parameters
            if ( this.searchParams.Bedrooms.length > 0 ) {
                if ( this.searchParams.Bedrooms.endsWith( '+' ) ) {
                    filter.propertyFilter.minBedrooms = parseInt( this.searchParams.Bedrooms.replace( '+', '' ) );
                } else {
                    filter.propertyFilter.bedrooms = parseInt( this.searchParams.Bedrooms );
                }
            }

            // same with bathrooms
            if ( this.searchParams.Bathrooms.length > 0 ) {
                if ( this.searchParams.Bathrooms.endsWith( '+' ) ) {
                    filter.propertyFilter.minBathrooms = parseInt( this.searchParams.Bathrooms.replace( '+', '' ) );
                } else {
                    filter.propertyFilter.bathrooms = parseInt( this.searchParams.Bathrooms );
                }
            }
            return filter;
        },

        async runMetricsQuery( metricsRequest ) {
            let withV2 = this.useV2Endpoints();

            if ( withV2 ) {
                let call = await clientanalyticsapi.post( '/v2/property/metrics', metricsRequest );

                if ( call.status != 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    return;
                }

                let queryInfo = await call.json();

                let continueLoop = true;

                while ( continueLoop ) {
                    let args = {
                        query: queryInfo.query,
                        from: metricsRequest.filter.datefilter.fromDate,
                        to: metricsRequest.filter.datefilter.toDate
                    };

                    let call2 = await clientanalyticsapi.post( '/v2/property/metrics/results', args );

                    if ( call2.status == 202 ) {
                        // wait for 1 second and try again
                        await new Promise( resolve => setTimeout( resolve, 200 ) );
                        continue;
                    }

                    return await call2;
                }
            } else {
                let call = await clientanalyticsapi.post( '/property/metrics', metricsRequest );

                if ( call.status != 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    return;
                }

                return await call;
            }
        },
        async queryMetrics() {
            let metricsRequest = {
                metric: this.searchParams.Metric,
                interval: this.searchParams.Interval,
                filter: this.getFilter()
            };

            let queryMetric1 = this.runMetricsQuery( metricsRequest );

            let metrics2Request = JSON.parse( JSON.stringify( metricsRequest ) );
            metrics2Request.metric = this.searchParams.Metric2;

            let queryMetric2 = this.runMetricsQuery( metrics2Request );

            let resultMetric1 = await queryMetric1;
            let resultMetric2 = await queryMetric2;

            if ( resultMetric1.status != 200 || resultMetric2.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            this.drawChart( await resultMetric1.json(), await resultMetric2.json() );
        },
        reDrawChart() {
            let chartElement = document.getElementById( 'PropertyChart' );

            if ( !chartElement ) {
                return;
            }
            if ( this.chartData && this.chartOptions ) {
                let chart = new google.visualization.AreaChart( chartElement );
                chart.draw( this.chartData, this.chartOptions );
            }
        },
        drawChart( metric1result, metric2result ) {
            let myChart = new google.visualization.DataTable();

            let title1 = this.getMetricTextByValue( this.searchParams.Metric );
            let title2 = this.getMetricTextByValue( this.searchParams.Metric2 );

            myChart.addColumn( 'string', this.dateText );
            myChart.addColumn( 'number', title1 );
            myChart.addColumn( 'number', title2 );

            let chartElement = document.getElementById( 'PropertyChart' );

            if ( !chartElement ) {
                return;
            }

            let metric1Max = 0;
            let metric2Max = 0;

            metric1result.forEach( ( el, index ) => {
                if ( el.Metric > metric1Max ) {
                    metric1Max = el.Metric;
                }

                let metric2Value = metric2result[ index ].Metric;

                if ( metric2Value > metric2Max ) {
                    metric2Max = metric2Value;
                }

                myChart.addRow( [
                    dayjs( el.Date ).tz().format( 'DD MMM YYYY' ),
                    el.Metric,
                    metric2Value
                ] );
            } );

            let options = {
                enableInteractivity: true,
                colors: [ '#4382ce', '#f4516c' ],
                legend: 'top',
                width: '100%',
                title: null,
                fontSize: '12',
                italic: false,
                series: {
                    0: {
                        targetAxisIndex: 0,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        italic: false
                    },
                    1: {
                        targetAxisIndex: 1,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        italic: false
                    }
                },
                tooltip: {
                    trigger: 'hover'
                },
                vAxes: {
                    0: {
                        italic: false,
                        title: title1,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        viewWindow: {
                            min: 0,
                            max: metric1Max + 2
                        }
                    },
                    1: {
                        italic: false,
                        title: title2,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false
                        },
                        viewWindow: {
                            min: 0,
                            max: metric2Max + 2
                        }
                    }
                },
                vAxis: {
                    viewWindowMode: 'explicit',
                    format: '0',
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    }
                },
                hAxis: {
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false
                    }
                }
            };

            this.chartData = myChart;
            this.chartOptions = options;

            let chart = new google.visualization.AreaChart( chartElement );
            chart.draw( myChart, options );
        },
        async runDimentionsQuery( dimentionRequest ) {
            let call = await clientanalyticsapi.post( '/v2/property/dimentions', dimentionRequest );

            if ( call.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            let queryInfo = await call.json();

            let continueLoop = true;

            while ( continueLoop ) {
                let args = {
                    query1: queryInfo.query1,
                    query2: queryInfo.query2,
                    dimention: queryInfo.dimention
                };

                let call2 = await clientanalyticsapi.post( '/v2/property/dimentions/results', args );

                if ( call2.status == 202 ) {
                    // wait for 1 second and try again
                    await new Promise( resolve => setTimeout( resolve, 200 ) );
                    continue;
                }

                return await call2;
            }
        },
        async runTotalsQuery( dimentionRequest ) {
            let call = await clientanalyticsapi.post( '/v2/property/totals', dimentionRequest );

            if ( call.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            let queryInfo = await call.json();

            let continueLoop = true;

            while ( continueLoop ) {
                let args = {
                    query1: queryInfo.query1,
                    query2: queryInfo.query2,
                    dimention: queryInfo.dimention
                };

                let call2 = await clientanalyticsapi.post( '/v2/property/totals/results', args );

                if ( call2.status == 202 ) {
                    // wait for 1 second and try again
                    await new Promise( resolve => setTimeout( resolve, 200 ) );
                    continue;
                }

                return await call2;
            }
        },
        async loginProvinces( dimentionRequest ) {
            let call = await clientanalyticsapi.post( '/v2/property/provinces', dimentionRequest );

            if ( call.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            let queryInfo = await call.json();

            let continueLoop = true;

            while ( continueLoop ) {
                let args = {
                    query1: queryInfo.query1
                };

                let call2 = await clientanalyticsapi.post( '/v2/property/provinces/results', args );

                if ( call2.status == 202 ) {
                    // wait for 1 second and try again
                    await new Promise( resolve => setTimeout( resolve, 200 ) );
                    continue;
                }

                return await call2;
            }
        },
        async loginTowns( dimentionRequest ) {
            let call = await clientanalyticsapi.post( '/v2/property/towns', dimentionRequest );

            if ( call.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            let queryInfo = await call.json();

            let continueLoop = true;

            while ( continueLoop ) {
                let args = {
                    query1: queryInfo.query1
                };

                let call2 = await clientanalyticsapi.post( '/v2/property/towns/results', args );

                if ( call2.status == 202 ) {
                    // wait for 1 second and try again
                    await new Promise( resolve => setTimeout( resolve, 200 ) );
                    continue;
                }

                return await call2;
            }
        },

        async queryDimensions() {
            $( '.popover.show' ).popover( 'destroy' );

            let dimentionRequest = {
                metric: this.searchParams.Metric,
                dimention: this.searchParams.Dimention,
                take: this.resultsPerPage,
                skip: ( this.pagination.currentPage - 1 ) * this.resultsPerPage,
                filter: this.getFilter()
            };

            let dimention2Request = JSON.parse( JSON.stringify( dimentionRequest ) );
            dimention2Request.metric = this.searchParams.Metric2;

            let queryDimention1 = this.runDimentionsQuery( dimentionRequest );
            let queryDimention2 = this.runDimentionsQuery( dimention2Request );

            let totals1 = this.runTotalsQuery( dimentionRequest );
            let totals2 = this.runTotalsQuery( dimention2Request );

            let compareResultDimetion1 = null;
            let compareResultDimetion2 = null;

            let totalCompareResultDimetion1 = null;
            let totalCompareResultDimetion2 = null;

            let provinces = null;
            let towns = null;

            if ( this.compareWith == 'globalsameprovince' ) {
                let provincesResult = await this.loginProvinces( dimentionRequest );

                if ( provincesResult.status != 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    return;
                }

                provinces = await provincesResult.json();
            }

            if ( this.compareWith == 'globalsamelocation' ) {
                let townsResult = await this.loginTowns( dimentionRequest );

                if ( townsResult.status != 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    return;
                }

                towns = await townsResult.json();
            }

            if ( [ 'global', 'globalsameprovince', 'globalsamelocation', 'customdates' ].includes( this.compareWith ) ) {
                let compareDimetionRequest = JSON.parse( JSON.stringify( dimentionRequest ) );

                if ( this.searchCompareWith == 'customdates' ) {
                    compareDimetionRequest.filter.datefilter.fromDate = this.searchCompareFromDate;
                    compareDimetionRequest.filter.datefilter.toDate = this.searchCompareToDate;
                } else {
                    compareDimetionRequest.filter.propertyFilter.logins = [];
                }

                if ( this.searchCompareWith == 'globalsameprovince' ) {
                    compareDimetionRequest.filter.propertyFilter.provinces = provinces;
                }

                if ( this.searchCompareWith == 'globalsamelocation' ) {
                    compareDimetionRequest.filter.propertyFilter.towns = towns;
                }

                let compareDimention2Request = JSON.parse( JSON.stringify( dimention2Request ) );

                if ( this.searchCompareWith == 'customdates' ) {
                    compareDimention2Request.filter.datefilter.fromDate = this.searchCompareFromDate;
                    compareDimention2Request.filter.datefilter.toDate = this.searchCompareToDate;
                } else {
                    compareDimention2Request.filter.propertyFilter.logins = [];
                }

                if ( this.searchCompareWith == 'globalsameprovince' ) {
                    compareDimention2Request.filter.propertyFilter.provinces = provinces;
                }

                if ( this.searchCompareWith == 'globalsamelocation' ) {
                    compareDimention2Request.filter.propertyFilter.towns = towns;
                }

                let compareQueryDimention1 = this.runDimentionsQuery( compareDimetionRequest );
                let compareQueryDimention2 = this.runDimentionsQuery( compareDimention2Request );

                let compareTotals1 = this.runTotalsQuery( compareDimetionRequest );
                let compareTotals2 = this.runTotalsQuery( compareDimention2Request );

                let compareQueryResult1 = await compareQueryDimention1;
                let compareQueryResult2 = await compareQueryDimention2;

                let compareTotalsResult1 = await compareTotals1;
                let compareTotalsResult2 = await compareTotals2;

                if ( compareQueryResult1.status != 200 || compareQueryResult2.status != 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    return;
                }

                if ( compareTotalsResult1.status != 200 || compareTotalsResult2.status != 200 ) {
                    notify( {
                        title: 'An error',
                        text: 'An error has occurred while loading the data',
                        type: 'error'
                    } );
                    return;
                }

                compareResultDimetion1 = await compareQueryResult1.json();
                compareResultDimetion2 = await compareQueryResult2.json();

                totalCompareResultDimetion1 = await compareTotalsResult1.json();
                totalCompareResultDimetion2 = await compareTotalsResult2.json();
            }

            let resultDimetion1 = await queryDimention1;
            let resultDimetion2 = await queryDimention2;

            let totals1Result  = await totals1;
            let totals2Result  = await totals2;

            if ( resultDimetion1.status != 200 || resultDimetion2.status != 200 ) {
                notify( {
                    title: 'An error',
                    text: 'An error has occurred while loading the data',
                    type: 'error'
                } );
                return;
            }

            this.setTableData( await resultDimetion1.json(), await resultDimetion2.json(), compareResultDimetion1, compareResultDimetion2 );

            this.setTotals( await totals1Result.json(), await totals2Result.json(), totalCompareResultDimetion1, totalCompareResultDimetion2 );
        },
        setTableData( result1Dimention, result2Dimention, compareResult1Dimention, compareResult2Dimention ) {
            let rows = [];

            console.log( 'result1Dimention', result1Dimention );
            console.log( 'result2Dimention', result2Dimention );
            console.log( 'compareResult1Dimention', compareResult1Dimention );
            console.log( 'compareResult2Dimention', compareResult2Dimention );

            let defaultNoOfProperties = 0;

            if ( [ 'country', 'device' ].includes( this.searchParams.Dimention ) ) {
                defaultNoOfProperties = 'N/A';
            }

            for ( let group of result1Dimention.Groups ) {
                let row = {
                    Group: group.Group,
                    NoOfAgents: {
                        Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                    },
                    NoOfProperties: {
                        Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                    },
                    UniqueListedProperties: {
                        Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                    },
                    AvgPrice: {
                        Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                        Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                    },
                    thinkspain: {
                        Total: { Metric1: 0, Metric2: 0 },
                        Standard: { Metric1: 0, Metric2: 0 },
                        Featured: { Metric1: 0, Metric2: 0 },
                        Premium: { Metric1: 0, Metric2: 0 }
                    },
                    Compare: {
                        NoOfAgents: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        UniqueListedProperties: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        NoOfProperties: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        AvgPrice: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        thinkspain: {
                            Total: { Metric1: 0, Metric2: 0 },
                            Standard: { Metric1: 0, Metric2: 0 },
                            Featured: { Metric1: 0, Metric2: 0 },
                            Premium: { Metric1: 0, Metric2: 0 }
                        }
                    }
                };

                for ( let result of group.MetricResults ) {
                    let eventName = result.EventName;

                    if ( eventName == 'noofagents-total' ) {
                        row.NoOfAgents.Total.Metric1 = result.Total;
                    } else if ( eventName == 'noofagents-standard' ) {
                        row.NoOfAgents.Standard.Metric1 = result.Total;
                    } else if ( eventName == 'noofagents-featured' ) {
                        row.NoOfAgents.Featured.Metric1 = result.Total;
                    } else if ( eventName == 'noofagents-featured-premium' ) {
                        row.NoOfAgents.Premium.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-total' ) {
                        row.UniqueListedProperties.Total.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-standard' ) {
                        row.UniqueListedProperties.Standard.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured' ) {
                        row.UniqueListedProperties.Featured.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                        row.UniqueListedProperties.Premium.Metric1 = result.Total;
                    } else if ( eventName == 'noofproperties-featured-premium' ) {
                        row.NoOfProperties.Premium.Metric1 = result.Total;
                        row.NoOfProperties.Total.Metric1 += result.Total;
                    } else if ( eventName == 'noofproperties-featured' ) {
                        row.NoOfProperties.Featured.Metric1 = result.Total;
                        row.NoOfProperties.Total.Metric1 += result.Total;
                    } else if ( eventName == 'noofproperties' ) {
                        row.NoOfProperties.Standard.Metric1 = result.Total;
                        row.NoOfProperties.Total.Metric1 += result.Total;
                    } else if ( eventName == 'avgprice-total' ) {
                        row.AvgPrice.Total.Metric1 = result.Total;
                    } else if ( eventName == 'avgprice-standard' ) {
                        row.AvgPrice.Standard.Metric1 = result.Total;
                    } else if ( eventName == 'avgprice-featured' ) {
                        row.AvgPrice.Featured.Metric1 = result.Total;
                    } else if ( eventName == 'avgprice-featured-premium' ) {
                        row.AvgPrice.Premium.Metric1 = result.Total;
                    } else if ( eventName.endsWith( 'featured-premium' ) ) {
                        row[ result.Source ].Premium.Metric1 += result.Total;
                        row[ result.Source ].Total.Metric1 += result.Total;
                    } else if ( eventName.endsWith( 'featured' ) ) {
                        row[ result.Source ].Featured.Metric1 += result.Total;
                        row[ result.Source ].Total.Metric1 += result.Total;
                    } else {
                        row[ result.Source ].Standard.Metric1 += result.Total;
                        row[ result.Source ].Total.Metric1 += result.Total;
                    }
                }
                rows.push( row );
            }

            for ( let group of result2Dimention.Groups ) {
                let row = {};
                for ( let existing of rows ) {
                    if ( existing.Group == group.Group ) {
                        row = existing;
                        break;
                    }
                }

                // if row does not exist, create it
                if ( !row.Group ) {
                    row = {
                        Group: group.Group,
                        NoOfAgents: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        UniqueListedProperties: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        NoOfProperties: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        AvgPrice: {
                            Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                            Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                        },
                        thinkspain: {
                            Total: { Metric1: 0, Metric2: 0 },
                            Standard: { Metric1: 0, Metric2: 0 },
                            Featured: { Metric1: 0, Metric2: 0 },
                            Premium: { Metric1: 0, Metric2: 0 }
                        },
                        Compare: {
                            NoOfAgents: {
                                Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                            },
                            UniqueListedProperties: {
                                Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                            },
                            NoOfProperties: {
                                Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                            },
                            AvgPrice: {
                                Total: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Standard: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Featured: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties },
                                Premium: { Metric1: defaultNoOfProperties, Metric2: defaultNoOfProperties }
                            },
                            thinkspain: {
                                Total: { Metric1: 0, Metric2: 0 },
                                Standard: { Metric1: 0, Metric2: 0 },
                                Featured: { Metric1: 0, Metric2: 0 },
                                Premium: { Metric1: 0, Metric2: 0 }
                            }
                        }
                    };
                    rows.push( row );
                }

                for ( let result of group.MetricResults ) {
                    let eventName = result.EventName;

                    if ( eventName == 'noofagents-total' ) {
                        row.NoOfAgents.Total.Metric2 = result.Total;
                    } else if ( eventName == 'noofagents-standard' ) {
                        row.NoOfAgents.Standard.Metric2 = result.Total;
                    } else if ( eventName == 'noofagents-featured' ) {
                        row.NoOfAgents.Featured.Metric2 = result.Total;
                    } else if ( eventName == 'noofagents-featured-premium' ) {
                        row.NoOfAgents.Premium.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-total' ) {
                        row.UniqueListedProperties.Total.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-standard' ) {
                        row.UniqueListedProperties.Standard.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured' ) {
                        row.UniqueListedProperties.Featured.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                        row.UniqueListedProperties.Premium.Metric2 = result.Total;
                    } else if ( eventName == 'noofproperties-featured-premium' ) {
                        row.NoOfProperties.Premium.Metric2 = result.Total;
                        row.NoOfProperties.Total.Metric2 += result.Total;
                    } else if ( eventName == 'noofproperties-featured' ) {
                        row.NoOfProperties.Featured.Metric2 = result.Total;
                        row.NoOfProperties.Total.Metric2 += result.Total;
                    } else if ( eventName == 'noofproperties' ) {
                        row.NoOfProperties.Standard.Metric2 = result.Total;
                        row.NoOfProperties.Total.Metric2 += result.Total;
                    } else if ( eventName == 'avgprice-total' ) {
                        row.AvgPrice.Total.Metric2 = result.Total;
                    } else if ( eventName == 'avgprice-standard' ) {
                        row.AvgPrice.Standard.Metric2 = result.Total;
                    } else if ( eventName == 'avgprice-featured' ) {
                        row.AvgPrice.Featured.Metric2 = result.Total;
                    } else if ( eventName == 'avgprice-featured-premium' ) {
                        row.AvgPrice.Premium.Metric2 = result.Total;
                    } else if ( eventName.endsWith( 'featured-premium' ) ) {
                        row[ result.Source ].Premium.Metric2 += result.Total;
                        row[ result.Source ].Total.Metric2 += result.Total;
                    } else if ( eventName.endsWith( 'featured' ) ) {
                        row[ result.Source ].Featured.Metric2 += result.Total;
                        row[ result.Source ].Total.Metric2 += result.Total;
                    } else {
                        row[ result.Source ].Standard.Metric2 += result.Total;
                        row[ result.Source ].Total.Metric2 += result.Total;
                    }
                }
            }

            if ( compareResult1Dimention ) {
                for ( let group of compareResult1Dimention.Groups ) {
                    let row = {};
                    for ( let existing of rows ) {
                        if ( existing.Group == group.Group ) {
                            row = existing;
                            break;
                        }
                    }

                    // if row does not exist, create it
                    if ( !row.Group ) {
                        continue;
                    }

                    for ( let result of group.MetricResults ) {
                        let eventName = result.EventName;

                        if ( eventName == 'noofagents-total' ) {
                            row.Compare.NoOfAgents.Total.Metric1 = result.Total;
                        } else if ( eventName == 'noofagents-standard' ) {
                            row.Compare.NoOfAgents.Standard.Metric1 = result.Total;
                        } else if ( eventName == 'noofagents-featured' ) {
                            row.Compare.NoOfAgents.Featured.Metric1 = result.Total;
                        } else if ( eventName == 'noofagents-featured-premium' ) {
                            row.Compare.NoOfAgents.Premium.Metric1 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-total' ) {
                            row.Compare.UniqueListedProperties.Total.Metric1 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-standard' ) {
                            row.Compare.UniqueListedProperties.Standard.Metric1 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-featured' ) {
                            row.Compare.UniqueListedProperties.Featured.Metric1 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                            row.Compare.UniqueListedProperties.Premium.Metric1 = result.Total;
                        } else if ( eventName == 'noofproperties-featured-premium' ) {
                            row.Compare.NoOfProperties.Premium.Metric1 = result.Total;
                            row.Compare.NoOfProperties.Total.Metric1 += result.Total;
                        } else if ( eventName == 'noofproperties-featured' ) {
                            row.Compare.NoOfProperties.Featured.Metric1 = result.Total;
                            row.Compare.NoOfProperties.Total.Metric1 += result.Total;
                        } else if ( eventName == 'noofproperties' ) {
                            row.Compare.NoOfProperties.Standard.Metric1 = result.Total;
                            row.Compare.NoOfProperties.Total.Metric1 += result.Total;
                        } else if ( eventName == 'avgprice-total' ) {
                            row.Compare.AvgPrice.Total.Metric1 = result.Total;
                        } else if ( eventName == 'avgprice-standard' ) {
                            row.Compare.AvgPrice.Standard.Metric1 = result.Total;
                        } else if ( eventName == 'avgprice-featured' ) {
                            row.Compare.AvgPrice.Featured.Metric1 = result.Total;
                        } else if ( eventName == 'avgprice-featured-premium' ) {
                            row.Compare.AvgPrice.Premium.Metric1 = result.Total;
                        } else if ( eventName.endsWith( 'featured-premium' ) ) {
                            row.Compare[ result.Source ].Premium.Metric1 += result.Total;
                            row.Compare[ result.Source ].Total.Metric1 += result.Total;
                        } else if ( eventName.endsWith( 'featured' ) ) {
                            row.Compare[ result.Source ].Featured.Metric1 += result.Total;
                            row.Compare[ result.Source ].Total.Metric1 += result.Total;
                        } else {
                            row.Compare[ result.Source ].Standard.Metric1 += result.Total;
                            row.Compare[ result.Source ].Total.Metric1 += result.Total;
                        }
                    }
                }
            }

            if ( compareResult2Dimention ) {
                for ( let group of compareResult2Dimention.Groups ) {
                    let row = {};
                    for ( let existing of rows ) {
                        if ( existing.Group == group.Group ) {
                            row = existing;
                            break;
                        }
                    }

                    // if row does not exist, create it
                    if ( !row.Group ) {
                        continue;
                    }

                    for ( let result of group.MetricResults ) {
                        let eventName = result.EventName;

                        if ( eventName == 'noofagents-total' ) {
                            row.Compare.NoOfAgents.Total.Metric2 = result.Total;
                        } else if ( eventName == 'noofagents-standard' ) {
                            row.Compare.NoOfAgents.Standard.Metric2 = result.Total;
                        } else if ( eventName == 'noofagents-featured' ) {
                            row.Compare.NoOfAgents.Featured.Metric2 = result.Total;
                        } else if ( eventName == 'noofagents-featured-premium' ) {
                            row.Compare.NoOfAgents.Premium.Metric2 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-total' ) {
                            row.Compare.UniqueListedProperties.Total.Metric2 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-standard' ) {
                            row.Compare.UniqueListedProperties.Standard.Metric2 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-featured' ) {
                            row.Compare.UniqueListedProperties.Featured.Metric2 = result.Total;
                        } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                            row.Compare.UniqueListedProperties.Premium.Metric2 = result.Total;
                        } else if ( eventName == 'noofproperties-featured-premium' ) {
                            row.Compare.NoOfProperties.Premium.Metric2 = result.Total;
                            row.Compare.NoOfProperties.Total.Metric2 += result.Total;
                        } else if ( eventName == 'noofproperties-featured' ) {
                            row.Compare.NoOfProperties.Featured.Metric2 = result.Total;
                            row.Compare.NoOfProperties.Total.Metric2 += result.Total;
                        } else if ( eventName == 'noofproperties' ) {
                            row.Compare.NoOfProperties.Standard.Metric2 = result.Total;
                            row.Compare.NoOfProperties.Total.Metric2 += result.Total;
                        } else if ( eventName == 'avgprice-total' ) {
                            row.Compare.AvgPrice.Total.Metric2 = result.Total;
                        } else if ( eventName == 'avgprice-standard' ) {
                            row.Compare.AvgPrice.Standard.Metric2 = result.Total;
                        } else if ( eventName == 'avgprice-featured' ) {
                            row.Compare.AvgPrice.Featured.Metric2 = result.Total;
                        } else if ( eventName == 'avgprice-featured-premium' ) {
                            row.Compare.AvgPrice.Premium.Metric2 = result.Total;
                        } else if ( eventName.endsWith( 'featured-premium' ) ) {
                            row.Compare[ result.Source ].Premium.Metric2 += result.Total;
                            row.Compare[ result.Source ].Total.Metric2 += result.Total;
                        } else if ( eventName.endsWith( 'featured' ) ) {
                            row.Compare[ result.Source ].Featured.Metric2 += result.Total;
                            row.Compare[ result.Source ].Total.Metric2 += result.Total;
                        } else {
                            row.Compare[ result.Source ].Standard.Metric2 += result.Total;
                            row.Compare[ result.Source ].Total.Metric2 += result.Total;
                        }
                    }
                }
            }

            /* [("beach-apartment", 1); ("flat", 2); ("penthouse", 3); ("studio", 4); ("apartment", 17); ("loft", 22)
                ("villa", 5);("finca-country-house", 6);("semi-detached-villa", 7);("terraced-villa", 8);("townhouse", 15);("cave-house", 19);("bungalow", 20);
                ("undeveloped-land", 9);("building-plot", 10);("ruin", 18);
                ("restaurant-bar", 11);("hotel", 12);("office", 13);("business", 14);("shop", 23);("commercial", 24);("guesthouse-b-&-b", 26);
                ("wooden-home", 21);("mobile-home", 25);
                ("garage", 16); ("unknown", 0)
            ] */
            let propertyTypesByName = {
                'beach-apartment': 1,
                'flat': 2,
                'penthouse': 3,
                'studio': 4,
                'apartment': 17,
                'loft': 22,
                'villa': 5,
                'finca-country-house': 6,
                'semi-detached-villa': 7,
                'terraced-villa': 8,
                'townhouse': 15,
                'cave-house': 19,
                'bungalow': 20,
                'undeveloped-land': 9,
                'building-plot': 10,
                'ruin': 18,
                'restaurant-bar': 11,
                'hotel': 12,
                'office': 13,
                'business': 14,
                'shop': 23,
                'commercial': 24,
                'guesthouse-b-&-b': 26,
                'wooden-home': 21,
                'mobile-home': 25,
                'garage': 16,
                'unknown': 0
            };

            // populate row with some more descriptive info
            for ( let row of rows ) {
                switch ( this.searchParams.Dimention ) {
                case 'language': {
                    row.GroupDescription = this.languages.filter( l => l.code == row.Group )[ 0 ].name;
                    break;
                }
                case 'device': {
                    row.GroupDescription = row.Group;
                    break;
                }
                case 'status': {
                    row.GroupDescription = row.Group;
                    break;
                }
                case 'type': {
                    let typeId = propertyTypesByName[ row.Group ];
                    if ( !typeId ) {
                        row.GroupDescription = row.Group;
                        break;
                    }
                    row.GroupDescription = this.propertyTypes.filter( t => t.Id == typeId )[ 0 ].Labels[ 'en' ];
                    break;
                }
                case 'country': {
                    for ( let country of this.countries ) {
                        if ( country.code.toUpperCase() == row.Group.toUpperCase() ) {
                            row.GroupDescription = country.name;
                            break;
                        }
                    }
                    break;
                }
                default:
                    row.GroupDescription = row.Group;
                    break;
                }
            }

            this.pagination.currentPage = result1Dimention.Page;
            this.pagination.total = result1Dimention.Total;
            this.pagination.totalPages = Math.ceil(
                this.pagination.total / this.resultsPerPage
            );

            // sort results by group
            if ( ![ 'price' ].includes( this.searchParams.Dimention ) ) {
                rows.sort( ( a, b ) => ( a.GroupDescription > b.GroupDescription ) ? 1 : -1 );
            }

            this.rows = rows;
        },
        setTotals( totals1, totals2, compare1, compare2 ) {
            let totals = {
                Total: {
                    Metric1: 0,
                    Metric2: 0
                },
                Standard: {
                    Metric1: 0,
                    Metric2: 0
                },
                Featured: {
                    Metric1: 0,
                    Metric2: 0
                },
                Premium: {
                    Metric1: 0,
                    Metric2: 0
                },
                thinkspain: {
                    Total: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    Standard: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    Featured: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    Premium: {
                        Metric1: 0,
                        Metric2: 0
                    }
                },
                Compare: {
                    Total: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    Standard: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    Featured: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    Premium: {
                        Metric1: 0,
                        Metric2: 0
                    },
                    thinkspain: {
                        Total: {
                            Metric1: 0,
                            Metric2: 0
                        },
                        Standard: {
                            Metric1: 0,
                            Metric2: 0
                        },
                        Featured: {
                            Metric1: 0,
                            Metric2: 0
                        },
                        Premium: {
                            Metric1: 0,
                            Metric2: 0
                        }
                    }
                }
            };

            for ( let result of totals1 ) {
                let eventName = result.EventName;

                if ( eventName == 'noofagents-total' ) {
                    totals.Total.Metric1 = result.Total;
                } else if ( eventName == 'noofagents-standard' ) {
                    totals.Standard.Metric1 = result.Total;
                } else if ( eventName == 'noofagents-featured' ) {
                    totals.Featured.Metric1 = result.Total;
                } else if ( eventName == 'noofagents-featured-premium' ) {
                    totals.Premium.Metric1 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-total' ) {
                    totals.Total.Metric1 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-standard' ) {
                    totals.Standard.Metric1 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-featured' ) {
                    totals.Featured.Metric1 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                    totals.Premium.Metric1 = result.Total;
                } else if ( eventName == 'noofproperties-featured-premium' ) {
                    totals.Premium.Metric1 = result.Total;
                    totals.Total.Metric1 += result.Total;
                } else if ( eventName == 'noofproperties-featured' ) {
                    totals.Featured.Metric1 = result.Total;
                    totals.Total.Metric1 += result.Total;
                } else if ( eventName == 'noofproperties' ) {
                    totals.Standard.Metric1 = result.Total;
                    totals.Total.Metric1 += result.Total;
                } else if ( eventName == 'avgprice-total' ) {
                    totals.Total.Metric1 = result.Total;
                } else if ( eventName == 'avgprice-standard' ) {
                    totals.Standard.Metric1 = result.Total;
                } else if ( eventName == 'avgprice-featured' ) {
                    totals.Featured.Metric1 = result.Total;
                } else if ( eventName == 'avgprice-featured-premium' ) {
                    totals.Premium.Metric1 = result.Total;
                } else if ( eventName.endsWith( 'featured-premium' ) ) {
                    totals[ result.Source ].Premium.Metric1 += result.Total;
                    totals[ result.Source ].Total.Metric1 += result.Total;
                } else if ( eventName.endsWith( 'featured' ) ) {
                    totals[ result.Source ].Featured.Metric1 += result.Total;
                    totals[ result.Source ].Total.Metric1 += result.Total;
                } else {
                    totals[ result.Source ].Standard.Metric1 += result.Total;
                    totals[ result.Source ].Total.Metric1 += result.Total;
                }
            }

            for ( let result of totals2 ) {
                let eventName = result.EventName;

                if ( eventName == 'noofagents-total' ) {
                    totals.Total.Metric2 = result.Total;
                } else if ( eventName == 'noofagents-standard' ) {
                    totals.Standard.Metric2 = result.Total;
                } else if ( eventName == 'noofagents-featured' ) {
                    totals.Featured.Metric2 = result.Total;
                } else if ( eventName == 'noofagents-featured-premium' ) {
                    totals.Premium.Metric2 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-total' ) {
                    totals.Total.Metric2 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-standard' ) {
                    totals.Standard.Metric2 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-featured' ) {
                    totals.Featured.Metric2 = result.Total;
                } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                    totals.Premium.Metric2 = result.Total;
                } else if ( eventName == 'noofproperties-featured-premium' ) {
                    totals.Premium.Metric2 = result.Total;
                    totals.Total.Metric2 += result.Total;
                } else if ( eventName == 'noofproperties-featured' ) {
                    totals.Featured.Metric2 = result.Total;
                    totals.Total.Metric2 += result.Total;
                } else if ( eventName == 'noofproperties' ) {
                    totals.Standard.Metric2 = result.Total;
                    totals.Total.Metric2 += result.Total;
                } else if ( eventName == 'avgprice-total' ) {
                    totals.Total.Metric2 = result.Total;
                } else if ( eventName == 'avgprice-standard' ) {
                    totals.Standard.Metric2 = result.Total;
                } else if ( eventName == 'avgprice-featured' ) {
                    totals.Featured.Metric2 = result.Total;
                } else if ( eventName == 'avgprice-featured-premium' ) {
                    totals.Premium.Metric2 = result.Total;
                } else if ( eventName.endsWith( 'featured-premium' ) ) {
                    totals[ result.Source ].Premium.Metric2 += result.Total;
                    totals[ result.Source ].Total.Metric2 += result.Total;
                } else if ( eventName.endsWith( 'featured' ) ) {
                    totals[ result.Source ].Featured.Metric2 += result.Total;
                    totals[ result.Source ].Total.Metric2 += result.Total;
                } else {
                    totals[ result.Source ].Standard.Metric2 += result.Total;
                    totals[ result.Source ].Total.Metric2 += result.Total;
                }
            }

            if ( compare1 ) {
                for ( let result of compare1 ) {
                    let eventName = result.EventName;

                    if ( eventName == 'noofagents-total' ) {
                        totals.Compare.Total.Metric1 = result.Total;
                    } else if ( eventName == 'noofagents-standard' ) {
                        totals.Compare.Standard.Metric1 = result.Total;
                    } else if ( eventName == 'noofagents-featured' ) {
                        totals.Compare.Featured.Metric1 = result.Total;
                    } else if ( eventName == 'noofagents-featured-premium' ) {
                        totals.Compare.Premium.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-total' ) {
                        totals.Compare.Total.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-standard' ) {
                        totals.Compare.Standard.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured' ) {
                        totals.Compare.Featured.Metric1 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                        totals.Compare.Premium.Metric1 = result.Total;
                    } else if ( eventName == 'noofproperties-featured-premium' ) {
                        totals.Compare.Premium.Metric1 = result.Total;
                        totals.Compare.Total.Metric1 += result.Total;
                    } else if ( eventName == 'noofproperties-featured' ) {
                        totals.Compare.Featured.Metric1 = result.Total;
                        totals.Compare.Total.Metric1 += result.Total;
                    } else if ( eventName == 'noofproperties' ) {
                        totals.Compare.Standard.Metric1 = result.Total;
                        totals.Compare.Total.Metric1 += result.Total;
                    } else if ( eventName == 'avgprice-total' ) {
                        totals.Compare.Total.Metric1 = result.Total;
                    } else if ( eventName == 'avgprice-standard' ) {
                        totals.Compare.Standard.Metric1 = result.Total;
                    } else if ( eventName == 'avgprice-featured' ) {
                        totals.Compare.Featured.Metric1 = result.Total;
                    } else if ( eventName == 'avgprice-featured-premium' ) {
                        totals.Compare.Premium.Metric1 = result.Total;
                    } else if ( eventName.endsWith( 'featured-premium' ) ) {
                        totals.Compare[ result.Source ].Premium.Metric1 += result.Total;
                        totals.Compare[ result.Source ].Total.Metric1 += result.Total;
                    } else if ( eventName.endsWith( 'featured' ) ) {
                        totals.Compare[ result.Source ].Featured.Metric1 += result.Total;
                        totals.Compare[ result.Source ].Total.Metric1 += result.Total;
                    } else {
                        totals.Compare[ result.Source ].Standard.Metric1 += result.Total;
                        totals.Compare[ result.Source ].Total.Metric1 += result.Total;
                    }
                }
            }

            if ( compare2 ) {
                for ( let result of compare2 ) {
                    let eventName = result.EventName;

                    if ( eventName == 'noofagents-total' ) {
                        totals.Compare.Total.Metric2 = result.Total;
                    } else if ( eventName == 'noofagents-standard' ) {
                        totals.Compare.Standard.Metric2 = result.Total;
                    } else if ( eventName == 'noofagents-featured' ) {
                        totals.Compare.Featured.Metric2 = result.Total;
                    } else if ( eventName == 'noofagents-featured-premium' ) {
                        totals.Compare.Premium.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-total' ) {
                        totals.Compare.Total.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-standard' ) {
                        totals.Compare.Standard.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured' ) {
                        totals.Compare.Featured.Metric2 = result.Total;
                    } else if ( eventName == 'uniquelistedproperties-featured-premium' ) {
                        totals.Compare.Premium.Metric2 = result.Total;
                    } else if ( eventName == 'noofproperties-featured-premium' ) {
                        totals.Compare.Premium.Metric2 = result.Total;
                        totals.Compare.Total.Metric2 += result.Total;
                    } else if ( eventName == 'noofproperties-featured' ) {
                        totals.Compare.Featured.Metric2 = result.Total;
                        totals.Compare.Total.Metric2 += result.Total;
                    } else if ( eventName == 'noofproperties' ) {
                        totals.Compare.Standard.Metric2 = result.Total;
                        totals.Compare.Total.Metric2 += result.Total;
                    } else if ( eventName == 'avgprice-total' ) {
                        totals.Compare.Total.Metric2 = result.Total;
                    } else if ( eventName == 'avgprice-standard' ) {
                        totals.Compare.Standard.Metric2 = result.Total;
                    } else if ( eventName == 'avgprice-featured' ) {
                        totals.Compare.Featured.Metric2 = result.Total;
                    } else if ( eventName == 'avgprice-featured-premium' ) {
                        totals.Compare.Premium.Metric2 = result.Total;
                    } else if ( eventName.endsWith( 'featured-premium' ) ) {
                        totals.Compare[ result.Source ].Premium.Metric2 += result.Total;
                        totals.Compare[ result.Source ].Total.Metric2 += result.Total;
                    } else if ( eventName.endsWith( 'featured' ) ) {
                        totals.Compare[ result.Source ].Featured.Metric2 += result.Total;
                        totals.Compare[ result.Source ].Total.Metric2 += result.Total;
                    } else {
                        totals.Compare[ result.Source ].Standard.Metric2 += result.Total;
                        totals.Compare[ result.Source ].Total.Metric2 += result.Total;
                    }
                }
            }

            this.totals = totals;
        },
        appLoading( block ) {
            this.$store.dispatch( 'appLoading', block );
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/clientanalytics/property/form/index.vue